import { Injectable } from '@angular/core';
import { Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AwsHttp } from '../aws/http';
import { ErrorHandler } from '../restapi/error-handler';
import { Preferences, User } from '../user/user';

@Injectable()
export class UserPreferencesService {

    constructor(private http: AwsHttp, private errorHandler: ErrorHandler) { }

    get(user: User): Observable<Preferences> {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let baseUrl = user.ApiServiceUrl;
        let url = `${baseUrl}/${user.Cognito.IdentityId}/preferences`;
        return this.http
            .get(url, { headers: headers })
            .map((response: Response) => {
                let preferences = response.json();
                this.setDefault(preferences);
                user.Preferences = preferences;
                return preferences;
            })
            .catch((response: Response) => this.errorHandler.throwError(response));
    }

    update(user: User): Observable<Preferences> {
        return Observable.of(new Preferences());
        // let headers = new Headers({
        //     'Content-Type': 'application/json'
        // });
        // let baseUrl = user.MgmtServUrl;
        // let url = `${baseUrl}/${user.Cognito.IdentityId}/preferences`;
        // return this.http
        //     .put(url, JSON.stringify({ Preferences: user.Preferences }), { headers: headers })
        //     .map((response: Response) => response.json())
        //     .catch((response: Response) => this.errorHandler.throwError(response));
    }

    setDefault(preferences: Preferences): void {
        let defaultPreferences = new Preferences();
        for (let prop in defaultPreferences) {
            if (!preferences.hasOwnProperty(prop)) {
                preferences[prop] = defaultPreferences[prop];
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/user/preferences.service.ts